import { Component, Optional, Inject } from '@angular/core';
import { AddContactFieldsComponent } from 'src/app/master-config-components/micro-apps/website/edit-website/v-2/editor/add-contact-fields/add-contact-fields.component';
import { CrmServiceService } from '../../../service/crm-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-custom-form',
  templateUrl: './custom-form.component.html',
  styleUrls: ['./custom-form.component.scss'],
})
export class CustomFormComponent {
  btnLoader: boolean = false;
  formTitle: string = '';
  name: string = '';
  mobile: string = '';
  email: string = '';
  addTitle: boolean = false;
  srcWidth: number = 0;
  listFields: any = [];
  rating: number = 0;
  editData: any = {};
  showExistingFields: boolean = false;

  constructor(
    private crmService: CrmServiceService,
    private snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<CustomFormComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.getScreenSize();
  }

  ngOnInit() {
    if (!this.data.create) {
      this.getEditData();
    }
  }

  configureFields(from?: string) {
    // if(this.listFields.length <= 0 || from === 'addMore'){
    this.showExistingFields = false;
    let width = this.srcWidth < 475 ? '100%' : '50%';
    let dialog = this.crmService.openServiceDialog(
      AddContactFieldsComponent,
      '100vh',
      width,
      '100vw',
      { screen: 'CUSTOM_FORM' },
    );
    dialog.afterClosed().subscribe({
      next: (res: any) => {
        if (res) {
          this.listFields.push(res);
          this.listFields = this.listFields.map((field) => ({
            ...field,
            dataType: field.dataType?.toUpperCase(),
          }));
          this.snackBar.open('Field added successfully', 'Close', {
            duration: 1500,
          });
        }
      },
    });
    // }
    // else{
    //   this.showExistingFields = true
    // }
  }

  addOption(fieldIndex: number) {
    this.listFields[fieldIndex].value.push({
      label: '',
      value: '',
    });
  }

  removeOption(fieldIndex: number, optionIndex: number) {
    this.listFields[fieldIndex].value.splice(optionIndex, 1);
  }

  deleteField(index: number) {
    this.listFields.splice(index, 1);
  }

  openTitleEdit(event: Event) {
    event.stopPropagation();
    this.addTitle = true;
  }

  saveTitle() {
    const trimmedTitle = this.formTitle?.trim();

    if (!trimmedTitle) {
      this.formTitle = '';
      this.addTitle = false;
      return;
    }
    this.formTitle = trimmedTitle;
    this.addTitle = false;
  }

  getScreenSize() {
    this.srcWidth = window.innerWidth;
  }

  setRating(value: number) {
    this.rating = value;
  }

  createForm() {
    this.btnLoader = true;
    let payload = {
      ...(!this.data.create && { id: this?.data?.data?.id }),
      businessId: localStorage.getItem('businessId'),
      formName: this.formTitle,
      userName: 'Name',
      mobile: 'Mobile Number',
      email: 'Email',
      fields: this.listFields,
      staffDetails: {
        id: localStorage.getItem('staffId'),
        name: localStorage.getItem('staffName'),
      },
    };
    this.crmService.createCustomForm(payload).subscribe({
      next: (res: any) => {
        this.snackBar.open('Custom form created succesfully', 'Close', {
          duration: 1500,
        });
        this.btnLoader = false;
        const createdForm = res?.data || res?.data?.data;
        const messageData = {
          type: 'SIMPO_FORM_CREATED',
          payload: { id: createdForm.id, name: createdForm.formName },
        };

        // This hits the Main Angular Wrapper
        window.parent.postMessage(messageData, '*');

        // Also hit the current window just in case
        window.postMessage(messageData, '*');
        this.closeDialog();
      },
      error: (err: any) => {
        this.snackBar.open('Failed to create form', 'Close', {
          duration: 1500,
        });
        this.btnLoader = false;
      },
    });
  }

  getEditData() {
    this.editData = this.data.data;
    this.formTitle = this.editData.formName;
    this.listFields = this.editData.fields;
  }

  closeDialog() {
    this.dialogRef.close();
  }

  closeEdit() {
    let disabled = this.listFields.some(
      (field) =>
        (field.dataType === 'CHECKBOX' ||
          field.dataType === 'RADIOBUTTON' ||
          field.dataType === 'DROPDOWN') &&
        field.value?.some(
          (opt: any) => !opt.label || opt.label.trim().length === 0,
        ),
    );

    if (disabled) {
      this.snackBar.open('Fields can not be empty', 'Close', {
        duration: 1500,
      });
    } else {
      this.showExistingFields = false;
    }
  }

  hasLongOption(options: any[]) {
    return options?.some(o => o.label?.trim().length > 20);
  }

  hasDuplicateOptions(options: any[]): boolean {
    const labels = options
      .map(o => o.label?.trim().toLowerCase())
      .filter(v => v); 
    return new Set(labels).size !== labels.length;
  }

  activeIndex = 0;

  toggleField(i: number) {
    this.activeIndex = this.activeIndex === i ? -1 : i;
  }
}
